import { IconButton, styled, IconButtonProps } from "@mui/material";
import { useTranslation } from "../../helpers/i18n";
import { defaultFocusOutline } from "../../helpers/accessibility";

export const StyledCloseButton = styled(IconButton)(({ theme }) => {
  const spacing = 20;
  return {
    position: "absolute",
    zIndex: theme.zIndex.modal,
    right: spacing,
    top: spacing,
    color: theme.palette.text.paper,
    width: "1rem",
    height: "1rem",
    "&:focus": {
      outline: defaultFocusOutline(theme),
      outlineOffset: 3,
    },
    [theme.breakpoints.up("md")]: {
      width: "2rem",
      height: "2rem",
    },
  };
});

type Props = Pick<IconButtonProps, "onClick" | "children">;

export function CloseButton(props: Props) {
  const { t } = useTranslation();
  return (
    <StyledCloseButton
      disableRipple
      aria-label={t("accessibility_close_alt_text")}
      {...props}
    />
  );
}
